// removed by extract-text-webpack-plugin
module.exports = {"container":"_2NL8R","map":"x3Es7"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Map/styles.css
 ** module id = 161
 ** module chunks = 1
 **/